export default {
  props: {
    valueField: {
      type: String,
      default: 'value',
    },

    textField: {
      type: String,
      default: 'text',
    },

    textHelpField: String,
  },

  methods: {
    getValue(obj) {
      if (obj === undefined) return
      const value = obj[this.valueField]

      return value === undefined ? obj : value
    },

    getText(obj) {
      if (obj === undefined) return ''
      const helpText = this.textHelpField ? `(${obj[this.textHelpField]})` : ''
      const text = obj[this.textField]
      return text === undefined ? '' : text + helpText
    },

    getTextByValue(values, value) {
      return values.filter(v => {
        const val = v[this.valueField]
        if (Array.isArray(value)) {
          return value.indexOf(val) > -1
        }

        return value === val + ''
      }).map(v => v[this.textField]).join(',')
    },
  },
}
